"use client"

import type { FunctionComponent, PropsWithChildren } from "react"

import { usePageContext } from "@/modules/jobSearch/components/PageContext/PageContextProvider"
import { LayoutChild } from "@/modules/layouts/components/Layout/LayoutChild"

type InteractiveResultsProps = PropsWithChildren<{
  hasAside: boolean
}>

export const InteractiveResults: FunctionComponent<InteractiveResultsProps> = ({ children, hasAside }) => {
  const { isUserLogged, savedSearch } = usePageContext()
  const hasAsideWithSavedSearch = hasAside || (isUserLogged && !!savedSearch)

  return (
    <LayoutChild {...(hasAsideWithSavedSearch ? { from: 1, to: 8 } : { variant: "large" })}>{children}</LayoutChild>
  )
}
